import { createRouter, createWebHistory } from "vue-router";
import routes from "./main";
import initRouterGuard from "./router.guard";

export default async function initRouter() {
    const router = createRouter({
        history: createWebHistory(`${__WEB_PREFIX__}`),
        routes: routes,
    });
    initRouterGuard(router);
    return router;
}
